import * as Types from 'src/actions/contract-corrections/create/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ContractCorrection from 'src/value-objects/ContractCorrections';
import ValidatorService from 'src/services/validation/Validation.service';

export interface CreateCorrectionContractAttempt extends Action {
  type: Types.CREATE_CORRECTION_CONTRACT_ATTEMPT;
}

export interface CreateCorrectionContractSuccess extends Action {
  type: Types.CREATE_CORRECTION_CONTRACT_SUCCESS;
  payload: ContractCorrection;
}

export interface CreateCorrectionContractFailure extends Action {
  type: Types.CREATE_CORRECTION_CONTRACT_FAILURE;
  payload: {};
}

export type CreateCorrectionContractAction = CreateCorrectionContractAttempt |
  CreateCorrectionContractSuccess |
  CreateCorrectionContractFailure;

export interface CreateCorrectionContractThunk extends
  ThunkAction<Promise<CreateCorrectionContractAction>, RootState, null> {
}

export const createCorrectionContractAttempt: ActionCreator<CreateCorrectionContractAttempt> = (
) => (
  {
    type: Types.CREATE_CORRECTION_CONTRACT_ATTEMPT,
  }
);

export const createCorrectionContractSuccess: ActionCreator<CreateCorrectionContractSuccess> = (
  correctionContract: ContractCorrection
) => (
  {
    type: Types.CREATE_CORRECTION_CONTRACT_SUCCESS,
    payload: correctionContract,
  }
);

export const createCorrectionContractFailure: ActionCreator<CreateCorrectionContractFailure> = (error: {}) => (
  {
    type: Types.CREATE_CORRECTION_CONTRACT_FAILURE,
    payload: error
  }
);

export const createContractCorrection: ActionCreator<CreateCorrectionContractThunk> = (
  investmentId: number,
  contractCorrection: ContractCorrection
): CreateCorrectionContractThunk => {

  return (dispatch: Dispatch<RootState>): Promise<CreateCorrectionContractAction> => {
    dispatch(createCorrectionContractAttempt());

    return ApiClient.contractCorrections.create(contractCorrection, {investmentId: investmentId})
      .then((response: AxiosResponse<ContractCorrection>): CreateCorrectionContractSuccess => {

        const successPayload: ContractCorrection = new ContractCorrection(response.data);

        return dispatch(createCorrectionContractSuccess(successPayload));
      }).catch((response: AxiosResponse<ContractCorrection>): CreateCorrectionContractFailure => {
        const errors = ValidatorService.translateValidations(JSON.parse(response.request.response).errors);

        return dispatch(createCorrectionContractFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/contract-corrections/create/CreateContractCorrections.actions.tsx